// ══════════════════════════════════════════════════════════════════
//  부위 아이콘 — **어떤 그림이 도착했는가.**  【2026-07-30 · 18장 반영】
//
//  ■ 이 파일은 **Phaser 를 안 쓴다.** 넷이 같은 표 하나를 읽어야 하기 때문이다:
//      `gearui.js`             화면에 얹는다
//      `scene.js`              밤 시작 때 로드한다
//      `prepare-sites.mjs`     배포본에 복사한다      ← 노드. Phaser 를 못 읽는다
//      `art_integration_check` 치수를 잰다             ← 노드
//    전에는 배포 복사 목록이 손으로 적힌 상수였다. 표가 둘이면 반드시 갈라진다 —
//    개발 서버에서는 보이고 **배포본에서만 아이콘이 사라지는** 종류의 사고가 그 자리다.
//
//  ■ **도착한 것만 적는다.** 없는 키를 로드하면 404 가 쌓이고, 그보다 나쁜 것은
//    「비어 있음」이 화면에서 「그림이 없는 부품」과 구별되지 않는다는 것이다.
//    **2026-07-30 끈 여섯이 도착해 24종이 다 찼다.** 그래도 이 표는 남긴다 —
//    빈 자리를 「그림이 없다」로 정직하게 말하는 것이 이 파일의 일이고,
//    부품이 늘거나 아트를 다시 뽑는 날 다시 비는 자리가 생긴다.
//
//  ■ 키 규약은 `gear-{부위}-{부품id}` 다. **돌만 id 가 고유명**이고(jandol…)
//    받침·끈·걸이는 `id === setId` 다(dry…). `gear.js` 의 정의부가 그렇게 되어 있다.
//
//  ■ 96×96 · 6색 · 이진 알파. 굽기 계약은 `assets/art/gear/v2/README.md`.
// ══════════════════════════════════════════════════════════════════

export const GEAR_ART_DIR = 'art/gear/v2';
export const GEAR_ART_SIZE = 96;          // 아이콘 칸(`GSKIN.icon`)과 같은 수여야 한다

export function gearArtKey(slot, id) { return `gear-${slot}-${id}`; }
export function gearArtFile(slot, id) { return `${GEAR_ART_DIR}/${gearArtKey(slot, id)}.png`; }

// 도착한 그림 — 부위마다 부품 id 목록. **여기 없으면 화면은 빈 칸을 그린다.**
export const GEAR_ART = {
  stone:  ['jandol', 'goreun', 'napjak', 'monan', 'chadol', 'mugeo'],
  cradle: ['dry', 'loose', 'rough', 'tamed', 'aged', 'hard'],
  // ⚠ 끈은 **파일 번호가 문서 순서와 달랐다**(2↔3). 생성 초가 같아 다운로드 번호가
  //   생성 순서를 보장하지 않았고, 그림으로 짝을 맞췄다 — 대응표는 v1/README.md.
  cord:   ['dry', 'loose', 'rough', 'tamed', 'aged', 'hard'],
  loop:   ['dry', 'loose', 'rough', 'tamed', 'aged', 'hard'],
};

/** 도착한 그림의 파일 경로 전부(앞에 `/` 없음 — 노드 쪽이 그대로 쓴다). */
export function gearArtFiles() {
  const out = [];
  for (const [slot, ids] of Object.entries(GEAR_ART)) {
    for (const id of ids) out.push(gearArtFile(slot, id));
  }
  return out;
}

/** Phaser 씬의 `preload()` 에서 부른다. 도착한 것만 요청한다. */
export function loadGearArt(scene) {
  for (const [slot, ids] of Object.entries(GEAR_ART)) {
    for (const id of ids) scene.load.image(gearArtKey(slot, id), `/${gearArtFile(slot, id)}`);
  }
}
